import Form from 'react-bootstrap/Form'
import React from 'react'

function SelectActividades({
  register,
  name,
  isValid,
  isInvalid,
  isDisabled,
  defaultValue,
  actividades,
  actividadesiibb
}) {
  return (
    <Form.Control
      as="select"
      isValid={isValid}
      isInvalid={isInvalid}
      ref={register()}
      disabled={isDisabled}
      defaultValue={defaultValue ? Object.values(defaultValue)[0] : 0}
      name={name}
    >
      <option value={0} disabled>
        Seleccione una actividad
      </option>
      {defaultValue && Object.keys(defaultValue)[0] === 'catID'
        ? actividades?.map((actividad) => (
            <option key={actividad.catID} value={actividad.catID}>
              ({actividad.catCodigo})- {actividad.catDescripcion}
            </option>
          ))
        : actividadesiibb?.map((act) => (
            <option key={act.aibID} value={act.aibID}>
              ({act.aibCodigoNaiib}) - {act.aibDescripcionNaiib}
            </option>
          ))}
    </Form.Control>
  )
}

export default SelectActividades
